import { SvgIcon, SvgIconProps } from "@/domains/icons/svg-icon"

export const MinusIcon = ({ ...rest }: SvgIconProps) => {
  return (
    <SvgIcon {...rest}>
      <path d="M20 12L4 12" stroke="currentColor"></path>
    </SvgIcon>
  )
}
